import * as React from 'react';

function SvgBinDeleteStrike1(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7 5.7v1.347h4.513V5.7H12.7zM11.3 5v2.047H7.813a.706.706 0 00-.087.005.706.706 0 00-.086-.005H5.5a.7.7 0 000 1.4h1.613v15.88a.7.7 0 00.7.7H21.58a.7.7 0 00.7-.7V8.447h1.846a.7.7 0 100-1.4h-2.353a.704.704 0 00-.096.006.706.706 0 00-.097-.006h-2.967V5a.7.7 0 00-.7-.7H12a.7.7 0 00-.7.7zm9.58 18.627H8.513V8.447H20.88v15.18zM14.5 11.443a.65.65 0 00-.65.65v7.56a.65.65 0 101.3 0v-7.56a.65.65 0 00-.65-.65zm2.85.65a.65.65 0 111.3 0v7.56a.65.65 0 11-1.3 0v-7.56zm-6.35-.65a.65.65 0 00-.65.65v7.56a.65.65 0 101.3 0v-7.56a.65.65 0 00-.65-.65z"
        fill={props.fill ? props.fill : '#414B56'}
      />
    </svg>
  );
}

export default SvgBinDeleteStrike1;
